module.exports = __webpack_public_path__ + "static/media/offline_exam_marks_reports.00d38b0e.png";